<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>分销商管理</el-breadcrumb-item>
      <el-breadcrumb-item>二级分销商</el-breadcrumb-item>

    </el-breadcrumb>
    <!-- 卡片开始 -->
    <el-card style="margin-top:20px;">
      <div class="conentBox">
        <div>
          <div>
            <el-input v-model="searchData.fxsSearch" placeholder="分销商名称" clearable />
          </div>

          <div>
            <el-select v-model="searchData.province" placeholder="全部省份" clearable>
              <el-option
                v-for="item in cityProvince"
                :key="item.provinceCode"
                :label="item.provinceName"
                :value="item.provinceCode"
              ></el-option>
            </el-select>

            <el-select v-model="searchData.status" placeholder="全部状态" clearable>
              <el-option
                v-for="item in statusOptions"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>

          <el-button type="primary" @click="searcnFn">查询</el-button>
        </div>

        <div>
          <el-button type="primary" plain @click="detailFn()">
            <i class="iconfont icon-jiahao"></i>
            添加分销商
          </el-button>
        </div>
      </div>
      <el-table
        :data="twoFxsTable"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column prop="Name" label="二级分销商"></el-table-column>
        <el-table-column prop="user_name" label="超管账号"></el-table-column>
        <el-table-column prop="UserCode" label="登录代码"></el-table-column>
        <el-table-column prop="LinkMan" label="联系人"></el-table-column>
        <el-table-column prop="Phone" label="电话"></el-table-column>
        <el-table-column prop="E_Mail" label="Email"></el-table-column>
        <el-table-column prop="Balance" label="余额"></el-table-column>
        <el-table-column prop="Status" label="分销商状态">
          <template slot-scope="scope">
            <img
              v-if="scope.row.Status==1"
              style=" vertical-align: middle;"
              src="@/images/worke/dl.png"
              alt
            />
            <img v-else style=" vertical-align: middle;" src="@/images/worke/dr.png" alt />
            <el-button type="text" @click="stateFn(scope.row)">
              <span v-if="scope.row.Status==1">上线</span>
              <span v-else>下线</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="setpassword(scope.row)">修改密码</el-button>
            <el-button type="text" @click="detailFn(scope.row)">详情</el-button>
            <el-button type="text" @click="clientFn(scope.row)">客户端</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="twoFxsPar.page"
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{twoFxsPar.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="twoFxsPar.page"  @current-change="handleCurrentChange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 卡片结束 -->

    <!-- 详情弹框开始 -->
    <twoDetailsDialog v-if="defailvisible" ref="defailDialog"></twoDetailsDialog>
    <!-- 详情弹框结束 -->

    <!-- 信息上下线弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="信息"
      :visible.sync="stateDialogVisible"
      :before-close="stateHandleClose"
      width="24%"
      top="30vh"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <div class="autorYj">
        <div>
          <div class="fswc">
            <el-radio-group v-model="statusXx">
              <el-radio :label="1">上线</el-radio>
              <el-radio :label="2">下线</el-radio>
            </el-radio-group>
          </div>
          <div class="autorBtn">
            <el-button class="btnCan" type="text" @click="canclFn">取消</el-button>
            <el-button class="btnSure" type="text" @click="msgFn()">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 信息上下线弹框结束 -->
    <el-dialog :close-on-click-modal="false"
      title="修改密码"
      :visible.sync="passwDialogVisible"
      :before-close="passwHandleClose"
      width="24%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>

      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="120px"
      >
        <el-form-item class="fsw" label="设置新密码:" prop="pass">
          <el-input type="password" placeholder="请输入新密码" v-model="ruleForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item class="fsw" label="请再次输入密码:" prop="checkPass">
          <el-input
            type="password"
            placeholder="请输入新密码"
            v-model="ruleForm.checkPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="autorBtn">
          <el-button class="btnCan" type="primary" @click="passwHandleClose">取消</el-button>
          <el-button class="btnSure" @click="submitForm('ruleForm')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import cityOptions from "@/assets/city.json";
import {
  getDistrbutorTwoListPost,
  adminDistributorTwoUpdateStatusPost,
  jfyDistributorTwoLogin,
  resetDistributorTwoPwd
} from "@/request/fxs.js";

import twoDetailsDialog from "./twoDetailsDialog.vue";
export default {
  components: {
    twoDetailsDialog
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      passwDialogVisible:false,
      ruleForm: {
        pass: "",
        checkPass: ""
      },
      userId:'',
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      defailvisible: false, // 详情弹框
      stateDialogVisible: false, // 上下线
      // 状态下拉框
      statusOptions: [
        {
          id: 1,
          label: "开通"
        },
        {
          id: 2,
          label: "停用"
        }
      ],
      // 列表传参
      twoFxsPar: {
        token: "",
        name: "",
        ProID: "",
        Status: "",
        page: 1,
        page_size: 8
      },
      // 搜索数据
      searchData: {
        fxsSearch: "",
        province: "",
        status: ""
      },
      // 表格绑定数据
      twoFxsTable: [],
      total: 1,
      Token: "",
      statusXx: "", // 状态搜索
      distributorId: "", // 分销商id保存
      cityProvince: [], // 省份数据
      value: "",
      radio: ""
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
    this.cityProvince = cityOptions;
    this.twoFxsPar = {
      token: this.Token,
      name: "",
      page: 1,
      page_size: 8
    };
    this.getList(this.twoFxsPar);
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            usertwo_id:this.userId,
            token:window.sessionStorage.getItem("Token"),
            password:this.ruleForm.pass,
            confirm_password:this.ruleForm.checkPass
          }
          resetDistributorTwoPwd(data).then(res => {
            if (res.data.rcode == 200) {
              this.$message.success(res.data.msg);
              this.passwDialogVisible = false;
              this.ruleForm = {
                pass: "",
                checkPass: ""
              };
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    setpassword(row){
      this.userId = row.UserID
      this.passwDialogVisible = true;
    },
    passwHandleClose() {
      this.ruleForm = {
        pass: "",
        checkPass: ""
      };
      this.passwDialogVisible = false;
    },
    // 客户端
    clientFn(row) {
      let data = {
        DistributorTwoId:row.DistributorID,
        token:window.sessionStorage.getItem('Token')
      }
      jfyDistributorTwoLogin(data).then(res=>{
        if(res.data.status=='ok'){
          window.open("/dis?data=" + JSON.stringify(res.data.result), "_blank");
        }else{
          this.$message.error(res.data.msg)
        }
      })
      // window.sessionStorage.setItem("menue", JSON.stringify(res.data.result.permission));
      // window.sessionStorage.setItem("Token", res.data.result.token);
      // window.sessionStorage.setItem('path',this.$route.path)
    },
    // 搜索
    searcnFn() {
      this.twoFxsPar.page = 1;
      this.twoFxsPar.name = this.searchData.fxsSearch;
      this.twoFxsPar.ProID = this.searchData.province;
      this.twoFxsPar.Status = this.searchData.status;
      this.getList(this.twoFxsPar);
    },
    // 获取列表数据
    getList(data) {
      getDistrbutorTwoListPost(data).then(res => {
        console.log(res);
        this.twoFxsTable = res.data.result.data;
        this.total = res.data.result.total;
        this.twoFxsPar.page = res.data.result.current_page
      });
    },
    // 点击状态关闭X
    stateHandleClose() {
      this.stateDialogVisible = false;
    },
    // 点击状态
    stateFn(row) {
      console.log(row);
      this.distributorId = row.DistributorID;
      this.statusXx = row.Status;
      if (row.Status == 1) {
        this.statusXx = 1;
      } else {
        this.statusXx = 2;
      }
      this.stateDialogVisible = true;
    },
    // 信息确认按钮
    msgFn() {
      this.statusPar = {
        distributortwo_id: this.distributorId,
        status: this.statusXx,
        token: this.Token
      };
      adminDistributorTwoUpdateStatusPost(this.statusPar).then(res => {
        console.log(res);
        if (res.data.rcode == 200) {
          this.stateDialogVisible = false;
          let upData = {
            token: this.Token
          };
          this.getList(upData);
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 信息按钮取消
    canclFn() {
      this.stateDialogVisible = false;
    },
    // 点击详情
    detailFn(row) {
      this.defailvisible = true;
      this.$nextTick(() => {
        this.$refs.defailDialog.defail(row);
      });
    },

    // 分页
    handleCurrentChange(val) {
      // console.log(val);
      this.twoFxsPar.page = val;
      this.getList(this.twoFxsPar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.autorDialog {
  /deep/.el-dialog--center {
    text-align: center;
    height: 266px;
  }
  .autorYj {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    .autorBtn {
      margin-top: 42px;
      .btnCan {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
      .btnSure {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
    }
  }
}
.conentBox {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
  > div:nth-child(1) {
    display: flex;
    // justify-content: flex-start;
    flex-wrap: wrap;
    > div:nth-child(1) {
      /deep/.el-input {
        width: 240px;
        margin-right: 20px;
        margin-bottom: 10px;
      }
    }
    > div:nth-child(2) {
      /deep/.el-select {
        width: 260px;
        margin-right: 20px;
        margin-bottom: 10px;

      }
    }
    .el-button {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      margin-bottom: 10px;

      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
  }
  > div:nth-child(2) {
    display: flex;
    justify-content: flex-end;
    .el-button {
      margin-bottom: 10px;
      width: 120px;
      display: flex;
      justify-content: center;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      // margin-right: -272px;
      color: #246deb;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
    }
  }
}
// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.autorBtn {
    margin-top: 18px;
    margin-left: -120px;
    display: flex;
    justify-content: center;
    .btnCan {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      color: #ffffff;
      border: none;
    }
    .btnSure {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      color: #ffffff;
    }
  }
</style>